import React from "react";
import CompanyLogo from "../CompanyLogo";
import RandomLogo from "../RandomLogo";
import { Link ,useLocation} from "react-router-dom";
import { routeNames } from "../../routeSegments";
import useModule from "../../hooks/useModule";


/* The above code is a React component called `InvestorInfo`. It takes two props, `props` and `menu`. */
const InvestorInfo = (props ,menu) => {
  // const location = useLocation();


  const {isPE} = useModule()

 /* The `getExitDetailReturnRow` function is a helper function that returns a JSX element representing
 a table row (`<tr>`) in the InvestorInfo component. */
  const getExitDetailReturnRow = (exitDetailReturnData) => (
    <tr className="border-b">
      <td className="whitespace-nowrap font-medium py-4 px-5 text-left w-[31%]">
        <div className="leading-8">
          {exitDetailReturnData.logo_path == "default.png" ||
            exitDetailReturnData.logo_path == "/default.png" ||
            !exitDetailReturnData.logo_path ? (
            <RandomLogo name={exitDetailReturnData.investor_name} />
          ) : (
            <CompanyLogo
              name={exitDetailReturnData.investor_name}
              page="company page"
              logo={exitDetailReturnData.logo_path}
            />
          )}
          {exitDetailReturnData?.investor_name && <Link
            to={isPE ? routeNames.peInvestorById(exitDetailReturnData.investor_id) : routeNames.vcInvestorById(exitDetailReturnData.investor_id)}
            className="hover:text-[#BC8B20] text-[#333333]">
            {exitDetailReturnData?.investor_name}
          </Link>}          
        </div>      
      </td>
      <td className="whitespace-nowrap  py-4 lg:pr-[1.3rem] 2xl:pr-[3rem] text-right w-[11%]">
        {exitDetailReturnData.multiple_return
          ?
          <div>{exitDetailReturnData.multiple_return + "x"}

          </div>

          : " "}

      </td>
      <td className="whitespace-nowrap  py-4 pl-[1.5rem] pr-[2.5rem] text-right w-[1%]">
        {exitDetailReturnData.irr ?
          <div >{exitDetailReturnData.irr + "%"}

          </div>
          : " "}
      </td>
      <td className="whitespace-nowrap  py-4 lg:pr-[1.3rem] 2xl:pr-[2.3rem] text-right w-[8%]">
        {exitDetailReturnData.amount_usd
          ? exitDetailReturnData.amount_usd
          : " "}
      </td>
      <td className="whitespace-nowrap  py-4 2xl:pr-[2.3rem] lg:pr-[1.3rem] text-right w-[5%]">
        {exitDetailReturnData.amount_inr
          ? exitDetailReturnData.amount_inr
          : " "}
      </td>      
    </tr>
  );

  return (
    <div className="lg:grid lg:grid-rows-8 gap-6">
      <div className="w-full lg:grid lg:grid-rows-8 lg:grid-flow-col overflow-x-auto scrollbar ">
        <div className="row-span-3">
          <div className="">
            <div className="row-span-1">
              <p className="text-[15pt] px-5 leading-[19pt] text-[#333333] lg:text-[17px] font-semibold  lg:leading-[22px]">
                Exits details return
              </p>
              {props?.data ? (
                props?.data?.length > 0 ? (
                  <table className="w-full mx-auto mt-2 flex-shrink-0">
                    <thead className=" text-[12pt] leading-[15pt] bg-[#F3F3F3] lg:text-[13px] lg:leading-[15px] font-semibold text-[#666666] font-semibold whitespace-nowrap">
                      <th className="py-2 flex px-5 text-left whitespace-nowrap">
                        Investor Name
                      </th>
                      <th className="whitespace-nowrap py-2 px-5 w-[15%]">
                        <p className="flex">
                          Return Multiple
                        </p>
                      </th>
                      <th className="whitespace-nowrap py-2 px-5 w-[10%]">
                        <p className="flex items-center justify-center">
                          IRR
                        </p>
                      </th>
                      <th className="whitespace-nowrap py-2 px-5 w-[10%]">
                        <p className="flex">
                          US$ M
                        </p>
                      </th>
                      <th className="whitespace-nowrap py-2 px-5 w-[10%]">
                        <p className="flex">
                          INR Cr
                        </p>
                      </th>
                    </thead>
                    {/* {props?.data? */}
                    <tbody className="text-[12pt] leading-[16pt] lg:text-[14px] lg:leading-[16px] font-sans_book_body text-[#333333] ">
                      {props?.data.map((value, index) => {
                        return getExitDetailReturnRow(value);
                      })}
                    </tbody>

                  </table>
                ) : (
                  <div className="flex items-center justify-center w-full px-5">
                      <p className="bg-[#F3F3F3] p-3 my-3 mx-auto text-[14px] text-[#333333] text-center leading-[16px] font-sans_book_body w-full">No data available</p>
                  </div>
                )
              ) : (
                <div className="w-full bg-[#FFFFFF]">
                  <center>
                    <div role="status" className=" h-[7rem]">
                      <svg
                        className="relative left-[0rem] top-[3rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    </div>
                  </center>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestorInfo;
